/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
export default {
  "sitecoreApiKey": "06932A28-2C57-4495-857B-1FE756B6B225",
  "sitecoreApiHost": "#{TOKEN_layoutServiceHost}#",
  "jssAppName": "gk-jss-app",
  "defaultLanguage": "en"
};